<!-- eslint-disable no-undef -->
<template>
  <div
    v-if="isLoad"
    class="container-wrapper service-request-page"
    @submit.prevent="myMethod"
  >
    <section
      class="container-bs"
      :class="{'container-disabled': activeLoading}"
    >
      <div v-if="activeLoading" class="spinner-container">
        <div class="lds-dual-ring" />
      </div>
      <!--      <h1 v-if="getMain.title" class="service-request-page__title">-->
      <!--        {{-->
      <!--          _.get(getMain, "title")-->
      <!--        }}-->
      <!--      </h1>-->
      <!--      <div v-if="getMain.requireFields" class="description service-request-page__description">-->
      <!--        {{-->
      <!--          _.get(getMain, "checkInfoLabel")-->
      <!--        }}-->
      <!--      </div>-->

      <div class="service-request-page__form">
        <div class="service-request-page__form-fields">
          <div
            ref="nav"
            class="service-request-page__nav"
          >
            <div
              v-for="(item, itemIndex) in stepItems"
              :key="`itemIndex-${itemIndex}`"
              ref="navItems"
              class="service-request-page__nav-item__container"
              :class="[
                item === currentStepIndex &&
                  `service-request-page__nav-item__container-active`
              ]"
            >
              <div
                class="service-request-page__nav-item"
                :class="[
                  item === currentStepIndex &&
                    `service-request-page__nav-item-active`
                ]"
                @click="changeStepTab(item)"
              >
                <span
                  class="service-request-page__nav-item-num"
                  :class="[
                    item === currentStepIndex &&
                      `service-request-page__nav-item-num_active`
                  ]"
                >
                  0{{ itemIndex + 1 }}
                </span>
                {{ labelTab(item + 1) }}
              </div>
            </div>
          </div>
          <div v-if="pageReloadData" class="service-request-page__content">
            <form>
              <Step1
                v-show="currentStepIndex === 0"
                v-if="!$route.query.dealer"
                :form="form"
                :submitForm="submitForm"
                :dealerItems="dealerItems"
                :errorMsgs="errorMsgs"
                :defaultForm="defaultForm"
                :changeFieldMap="changeFieldMap"
                :doneStepIndex="doneStepIndex"
                :resetStep="resetStep"
                @set-dealer="onSetDealer"
                @update:activeLoading="activeLoading = $event"
              />
              <Step2
                v-show="currentStepIndex === 1"
                :moboiltiesItems="moboiltiesItems"
                :form="form"
                :defaultForm="defaultForm"
                :dealerItems="dealerItems"
                :dealerServices="dealerServices"
                :errorMsgs="errorMsgs"
                :submitForm="submitForm"
                :disable="activeLoading"
                :workPeriod="workPeriod"
                :onServiceChanged="onServiceChanged"
                :requestServiceIn="requestServiceIn"
                :time="time"
                :changeTime="changeTime"
              />
              <Step3
                v-show="currentStepIndex === 2"
                :errorMsgs="errorMsgs"
                :form="form"
                :submitForm="submitForm"
                :onCheckboxUnknownChange="onCheckboxUnknownChange"
                :getVINCodeAction="getVINCodeAction"
                @update:vin_number="form.vin_number = $event"
                @update:state_number="form.state_number = $event"
                @update:unknown_number="form.unknown_number = $event"
                @update:activeLoading="activeLoading = $event"
              />
              <Step4
                v-show="currentStepIndex === 3"
                :form="form"
                :errorMsgs="errorMsgs"
                :defaultForm="defaultForm"
                :submitForm="submitForm"
              />
              <Step5
                v-show="currentStepIndex === 4"
                :moboiltiesItems="moboiltiesItems"
                :dealerServices="dealerServices"
                :changeStepTab="changeStepTab"
                :form="form"
                :errorMsgs="errorMsgs"
                :defaultForm="defaultForm"
                :submitForm="submitForm"
                :infoDealer="infoDealer"
                :dealer="dealer"
              />
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Step1 from '../components/main/Step1'
  import Step2 from '../components/main/Step2'
  import Step3 from '../components/main/Step3'
  import Step4 from '../components/main/Step4'
  import Step5 from '@/components/main/Step5.vue'

  export default {
    name: 'MainPage',

    components: {
      Step5,
      Step1,
      Step2,
      Step3,
      Step4
    },

    data () {
      return {
        queryClear: {},
        defaultForm: {},
        pageData: {},
        form: {
          is_validate: false
        },
        dealerItems: (this.getMain && this.getMain.form.dealer_id.items) || [],
        componentReady: false,
        showDatePicker: true,
        errorMsgs: {},
        isChangedForm: false,
        currentStepIndex: this.$route.query.dealer ? 1 : 0,
        doneStepIndex: this.$route.query.dealer ? 1 : 0,
        stepItems: this.$route.query.dealer ? [1, 2, 3, 4] : [0, 1, 2, 3, 4],
        requestServiceIn: 0,
        dealerServices: [],
        workPeriod: Object,
        workPeriodShort: [],
        workPhone: '',
        time: '',
        dealer: {},
        infoDealer: {
          text: ''
        },
        address: '',
        iframeStep2: false,
        pageReloadData: true,
        activeLoading: false,

        moboiltiesItems: []
      }
    },

    computed: {
    ...mapGetters(['getMain', 'isLoad', 'getPhoneType']),
    ...mapState(['currentLang']),

    disabledSteps () {
      if (this.currentStepIndex !== 1) {
        return false
      }
      return !(this.currentStepIndex === 1 && this.form.city_id)
    }
    },

    watch: {
      // 'form.vin_number': {
      //   handler (e) {
      //     console.log(e);
      //     if (e.replace(/\s/g, '').length === 17) {
      //       document.querySelector('div').focus()
      //       var tmp = document.createElement('input')
      //       document.body.appendChild(tmp)
      //       tmp.focus()
      //       document.body.removeChild(tmp)
      //       this.getVinCodeField(e)
      //     }
      //   }
      // },
      form: {
        deep: true,
        handler (e) {
          const emptyData = [
            e.periodId,
            e.appeal,
            e.first_name,
            e.last_name,
            e.state_number,
            e.email,
            e.date_time,
            e.comment,
            e.vin_number
          ]
          if (
            (emptyData.some(item => item !== '') ||
              e.model !== (this.$route.query.model || '') ||
              e.dealer_id !==
              (this.$route.query.dealer && Number(this.$route.query.dealer)) ||
              e.city_id !==
              (this.$route.query.city && Number(this.$route.query.city)) ||
              e.service_id !==
              (this.$route.query.service &&
                Number(this.$route.query.service)) ||
              (e.phone !== this.getPhoneType &&
                e.phone !== '+373-' &&
                e.phone !== '+380-') ||
              e.contact_method !== 1 ||
              e.policy !== false) &&
            !this.isChangedForm
          ) {
            this.changedForm()
          }
        }
      },
      $route (to, from) {
        if (from.name === 'service' && to.name === 'thank-you') {
          this.dealerName = _.get(this, '$store.state.dealer.dealerName', '')
          this.dealerId = _.get(this, '$store.state.dealer.dealerId', '')
          this.dealerCity = _.get(this, '$store.state.dealer.dealerCity', '')
          this.zipcode = _.get(this, '$store.state.dealer.zipcode', '')

          this.pushDataToDataLayer(
            {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language: _.get(this, 'currentLang', '')
              },
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'form-submit'
              },
              form: {
                name: 'lead-book-service',
                step: 'form-submit',
                conversion: '1'
              },
              dealer: {
                name: this.dealerName,
                dealerId: this.dealerId,
                city: this.dealerCity,
                zipcode: this.zipcode
              }
            },
            true
          )
        }
        if (from.name === 'thank-you' && to.name === 'service') {
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'form',
              sectionlv1: 'forms',
              sectionlv2: 'book-service',
              language: _.get(this, 'currentLang', '')
            },
            form: {
              name: 'lead-book-service',
              step: 'select-service',
              conversion: '0'
            }
          })
        }
      },
      currentStepIndex (v) {
        if (v === 0) {
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'form',
              sectionlv1: 'forms',
              sectionlv2: 'book-service',
              language: _.get(this, 'currentLang', '')
            },
            form: {
              name: 'lead-book-service',
              step: 'select-service',
              conversion: '0'
            }
          })
        }
        if (v === 1) {
          this.dealerName =
            _.get(this, 'infoDealer.text') || _.get(this, 'dealer.name')
          this.dealerId =
            _.get(this, 'infoDealer.dealerId') || _.get(this, 'dealer.uuid')
          this.dealerCity =
            _.get(this, 'infoDealer.city') ||
            _.get(this, 'dealer.addresses[0].city')
          this.zipcode =
            _.get(this, 'infoDealer.zipcode') ||
            _.get(this, 'dealer.addresses[0].zip')

          this.$store.commit('SET_DEALER', {
            dealerName: this.dealerName,
            dealerId: this.dealerId,
            dealerCity: this.dealerCity,
            zipcode: this.zipcode
          })

          this.pushDataToDataLayer(
            {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language:
                  _.get(this, 'currentLang') || _.get(this, 'dealer.language')
              },
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'contact-details'
              },
              form: {
                name: 'lead-book-service',
                step: 'contact-details',
                conversion: '0'
              },
              dealer: {
                name:
                  _.get(this, '$store.state.dealer.dealerName', false) ||
                  this.dealerName,
                dealerId:
                  _.get(this, '$store.state.dealer.dealerId', false) ||
                  this.dealerId,
                city:
                  _.get(this, '$store.state.dealer.dealerCity', false) ||
                  this.dealerCity,
                zipcode:
                  _.get(this, '$store.state.dealer.zipcode', false) ||
                  this.zipcode
              }
            },
            true
          )
        }
        if (v === 2) {
          this.dealerName =
            _.get(this, '$store.state.dealer.dealerName', false) ||
            _.get(this, 'infoDealer.text') ||
            _.get(this, 'dealer.name')
          this.dealerId =
            _.get(this, '$store.state.dealer.dealerId', false) ||
            _.get(this, 'infoDealer.dealerId') ||
            _.get(this, 'dealer.uuid')
          this.dealerCity =
            _.get(this, '$store.state.dealer.dealerCity', false) ||
            _.get(this, 'infoDealer.city') ||
            _.get(this, 'dealer.addresses[0].city')
          this.zipcode =
            _.get(this, '$store.state.dealer.zipcode', false) ||
            _.get(this, 'infoDealer.zipcode') ||
            _.get(this, 'dealer.addresses[0].zip')

          this.pushDataToDataLayer(
            {
              page: {
                category: 'tools',
                subCategory: 'form',
                sectionlv1: 'forms',
                sectionlv2: 'book-service',
                language:
                  _.get(this, 'currentLang') || _.get(this, 'dealer.language')
              },
              event: {
                name: 'formevent',
                componentName: 'book-service',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'confirm-booking'
              },
              form: {
                name: 'lead-book-service',
                step: 'confirm-booking',
                conversion: '0'
              },
              dealer: {
                name: this.dealerName,
                dealerId: this.dealerId,
                city: this.dealerCity,
                zipcode: this.zipcode
              }
            },
            true
          )
        }
      }
    },

    created () {
      this.printObjectValues(this.$route.query)
      if (this._.get(this.$route, 'query.country')) {
        this.$store.commit('setCurrentCountry', this.$route.query.country)
      }

      if (this._.get(this.$route, 'query.lang')) {
        this.$store.commit('setCurrentLang', this.$route.query.lang)
      }
      this.form = this.getDefaultForm()
    },

    async mounted () {
      if (this.$route.query.dealer) {
        await this.changeFieldMap(this.$route.query.dealer, {}, false)
      }

      // dataLayer start
      window.dataLayer = window.dataLayer || []
      window.tngaDataLayer = window.tngaDataLayer || {}

      const page = {
        category: 'tools',
        subCategory: 'form',
        sectionlv1: 'forms',
        sectionlv2: 'book-service',
        language: _.get(this, 'currentLang', '')
      }

      const form = {
        name: 'lead-book-service',
        step: 'select-service',
        conversion: '0'
      }

      window.tngaDataLayer = { page, form }
    // dataLayer end
    },

    methods: {
    ...mapActions(['submitServiceRequest', 'getServiceRequest']),

    printObjectValues (obj) {
      for (const key in obj) {
        if (obj[key]) {
          obj[key] = obj[key].split('?')[0]
        }
      }
    },
    scrollToActiveTab () {
      const nav = this.$refs.nav
      const items = this.$refs.navItems

      if (!nav || !items.length) return

      const activeItem = items[this.currentStepIndex]

      if (!activeItem) return
      nav.scrollTo({
        left:
          activeItem.offsetLeft -
          nav.offsetWidth / 2 +
          activeItem.offsetWidth / 2,
        behavior: 'smooth'
      })
    },
    myMethod (e) {
      e.preventDefault()
    },
    onServiceChanged (e) {
      if (this.currentStepIndex === 1) {
        this.currentStepIndex = 1
        this.doneStepIndex = 1
      }
    },
    onCheckboxUnknownChange (e) {
      this.currentStepIndex = 2
      this.doneStepIndex = 2
    },
    resetStep () {
      this.currentStepIndex = 0
      this.doneStepIndex = 0
      this.form.service_id = ''
      this.form.date_time = ''
      this.form.mobility_id = ''
    },
    onSetDealer (id) {
      this.form.dealerId = id
    },
    labelTab (e) {
      return this.getMain.tabs['tab' + e].label
    },
    nextStep (e) {
      this.submitForm(e)
    },
    changeTime (e) {
      this.time = e
    },
    getDefaultForm () {
      return {
        model: this.$route.query.model || '',
        periodId: '',
        dealer_id: this.$route.query.dealer && Number(this.$route.query.dealer),
        appeal: 1,
        first_name: '',
        last_name: '',
        state_number: '',
        engine: '',
        year: '',
        mobility_id: '',
        sub_service_id: '',
        unknown_number: false,
        city_id: this.$route.query.city && Number(this.$route.query.city),
        service_id: '',
        phone: this.getPhoneType === '+373' ? '' : this.getPhoneType,
        email: '',
        date_time: '',
        comment: '',
        vin_number: '',
        contact_method: '',
        policy: true,
        marketing: true
      }
    },
    async getVINCodeAction (code) {
      try {
        this.activeLoading = true
        const data = await this.getServiceRequest({
          submitUrl: `/service-check-vin/${code}`
        })
        if (!this.form.unknown_number) {
          this.activeLoading = false
        }
        return data
      } catch (error) {
        this.activeLoading = false
      }
    },
    async changeFieldMap (id, data) {
      if (id === this.form.dealerId) return
      try {
        this.moboiltiesItems = []
        this.dealer = data
        this.form.date_time = ''
        this.form.city_id = ''
        this.form.service_id = this.$route.query.service ? Number(this.$route.query.service) : ''
        this.doneStepIndex = 0
        this.resetDatePicker()
        this.infoDealer = {}
        const errors = await this.getServiceRequest({
          submitUrl: `/dealer/dealer?id=${id}`
        })
        if (!errors) {
          return this.$router.push('/404')
        }
        this.form.mobility_id = ''
        this.dealerServices = errors.services
        this.moboiltiesItems = errors.mobility
        this.form.dealer_id = errors.value
        this.form.dealerId = errors.value
        this.form.city_id = errors.city_id
        this.address = errors.address
        this.requestServiceIn = errors.requestServiceIn
        this.workPeriod = errors.workPeriod
        this.workPeriodShort = errors.workPeriodShort
        this.workPhone = errors.phone
        this.infoDealer = errors
        this.time = null
        this.time = ''
      } catch (er) {
        this.currentStepIndex = 1
        console.log('er', er)
      }
    },
    changeStepTab (index) {
      if (this.doneStepIndex >= index) {
        this.currentStepIndex = index
        this.$nextTick(() => {
          this.scrollToActiveTab()
        })
      }
    },
    changedForm () {
      this.isChangedForm = true
    },
    async clearForm () {
      this.pageReloadData = false
      setTimeout(() => {
        this.pageReloadData = true
      }, 100)
      Object.assign(this.$data, {
        pageData: {},
        form: {
          is_validate: false
        },
        dealerItems: (this.getMain && this.getMain.form.dealer_id.items) || [],
        componentReady: false,
        showDatePicker: true,
        errorMsgs: {},
        isChangedForm: false,
        currentStepIndex: 0,
        doneStepIndex: 0,
        stepItems: [0, 1, 2, 3],
        requestServiceIn: 0,
        workPeriod: Object,
        workPeriodShort: [],
        workPhone: '',
        dealerServices: [],
        time: '',
        dealer: {},
        infoDealer: {
          text: ''
        },
        address: '',
        iframeStep2: false
      })
      this.form = this.getDefaultForm()
      const inputs = [
        ...document.querySelectorAll(
          '.input-wrapper input, .input-wrapper textarea'
        )
      ]
      inputs.forEach(input => {
        input.value = ''
      })
      this.dealerItems = []
      this.showDatePicker = false
      await this.$nextTick()
      this.showDatePicker = true
    },
    async submitForm (isValidate = true) {
      this.errorMsgs = {}

      const payload = {
        ...this.form,
        is_validate: this.currentStepIndex === 4,
        date_time: this.form.date_time && this.form.date_time / 1000
      }

      const errorFn = errors => {
        if (typeof errors !== 'object') {
          console.warn('response errors is not a object', { errors })
        }
        Object.keys(errors).forEach(errKey => {
          this.$set(this.errorMsgs, errKey, errors[errKey])
        })
      }

      try {
        const errors = await this.submitServiceRequest({
          submitUrl: `/service${
            this._.get(this.$route, 'query.country')
              ? '?country=' + this._.get(this.$route, 'query.country')
              : ''
          }`,
          form: payload
        })
        if (errors.title) {
          const data = {
            description: errors.description,
            title: errors.title
          }
          this.$router.push({ name: 'thank-you', params: data })
          setTimeout(() => {
            this.clearForm()
          }, 500)
          return
        }

        window.scrollTo({ top: 0, behavior: 'smooth' })

        if (errors.title) {
        } else {
          if (isValidate) {
            errorFn(errors)
          }
        }
      } catch (e) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        const errors = e && e.response && e.response.data
        console.error('FAILED: submitServiceRequest')
        console.log({ e })

        const oldStep = this.currentStepIndex
        if (
          this.currentStepIndex === 0 &&
          !errors.dealerId
        ) {
          if (this.$route.query.dealer) {
            this.$set(this, 'currentStepIndex', 2)
            this.doneStepIndex = 2
            this.scrollToActiveTab()
          } else {
            this.$set(this, 'currentStepIndex', 1)
            if (!this.form.date_time && !this.form.service_id) {
              this.currentStepIndex = 1
              this.doneStepIndex = 1
              this.scrollToActiveTab()
            }
          }
          this.errorMsgs = {}
          return
        }
        if (
          this.currentStepIndex === 1 &&
          !errors.service_id &&
          !errors.date_time &&
          !errors.mobility_id &&
          ((this.$route.query.dealer && oldStep === 1) ||
            !this.$route.query.dealer)
        ) {
          this.$set(this, 'currentStepIndex', 2)
          this.doneStepIndex = 2
          this.errorMsgs = {}
          this.scrollToActiveTab()
          return
        }
        if (
          this.currentStepIndex === 2 &&
          !errors.state_number &&
          !errors.vin_number
        ) {
          this.$set(this, 'currentStepIndex', 3)
          if (this.doneStepIndex === 2) {
            this.doneStepIndex = 3
          }
          this.scrollToActiveTab()
          this.errorMsgs = {}
          return
        }
        if (
          this.currentStepIndex === 3 &&
          !errors.last_name &&
          !errors.first_name &&
          !errors.phone &&
          !errors.contact_method

        ) {
          this.$set(this, 'currentStepIndex', 4)
          if (this.doneStepIndex === 3) {
            this.doneStepIndex = 4
          }
          this.scrollToActiveTab()
          this.errorMsgs = {}
          return
        }
        if (isValidate) {
          errorFn(errors)
        }
      }
    },
    resetDatePicker () {
      try {
        this.form.date_time = ''
        if (this.$refs.datePicker) {
          this.$refs.datePicker.date = ''
          this.$refs.datePicker.time = ''
        }
      } catch (er) {
        console.log(er)
      }
    },

    pushDataToDataLayer (
      params = {} || window.tngaDataLayer,
      pushDataLayer = false
    ) {
      window.dataLayer = window.dataLayer || []
      window.tngaDataLayer = { ...params }

      if (pushDataLayer) window.dataLayer.push({ event: 'formevent' })
    }
    }
  }
</script>

<style lang="scss">
  .iframe{
    .service-request-page{
      min-height: unset !important;
    }
  }

.service-request-page {
  padding-top: 124px !important;
  padding-bottom: 124px;
  min-height: 100vh;
  @media (max-width: 1279px) {
    padding-top: 80px !important;
    max-width: 100% !important;
  }
  @media (max-width: 767px) {
    padding-top: 40px !important;
  }

  .description {
    margin-bottom: 64px;
    font-size: 16px;
    line-height: 22px;
    color: $c-black;
    text-align: left;
    font-family: 'NobelWGL-Book', sans-serif;
    letter-spacing: 2px;
    max-width: 552px;

    @media (max-width: 767px) {
      margin-bottom: 16px;
    }
  }

  .service-request-page__title {
    font-family: 'NobelWGL-Book', sans-serif;
    color: $c-black;
    font-size: 48px;
    line-height: 60px;
    text-align: left;
    text-transform: uppercase;
    margin-bottom: 16px;
    letter-spacing: 2px;
  }

  @include mobile {
    padding-bottom: 40px;
  }

  &__fields {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  &__content {

    .icon-left {
      position: relative;
      top: -1px;
      margin-left: 8px;
      color: $c-white;
    }

    .button {
      width: unset;
    }

    @include mobile {
      max-width: 100%;
    }
  }

  &__form {
    @include mobile {
      padding-bottom: 5px;
      // margin-top: 40px;
    }

    &-filters {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
      }
    }

    &-fields {
      @media (min-width: 767.9px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > * {
          width: 100%;
        }
      }
    }

    &-input {
      // min-width: 335px;
      margin-bottom: 16px;

      @include mobile {
        min-width: 100%;
        margin-bottom: 5px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__table {
    margin: 40px 0;

    @include mobile {
      margin: 20px 0;
    }
  }

  &__editor-wrapper {
    padding-top: 16px;
    margin-bottom: 16px;

    @include mobile {
      padding-top: 12px;
      //margin-bottom: 0;
    }
  }

  &__editor {
    padding: 24px 0 24px 0;
    text-align: left;
    border-top: 1px solid $c-silver;
    border-bottom: 1px solid $c-silver;

    p, sup {
      font-size: 15px;
      font-weight: 400;
      line-height: 19px;
      color: $c-gray;
    }

    * {
      font-family: "NobelWGL";
      color: $c-gray-dark;
      text-align: left;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: $c-black;
    }

    h1 {
      font-family: "NobelWGL";
      font-size: 40px;
      font-weight: 700;
      line-height: 44px;

      @include mobile {
        font-size: 24px;
        line-height: 1.42;
      }
    }

    h2 {
      font-family: "NobelWGL";
      // font-size: 28px;
      font-weight: 400;
      line-height: 35px;

      @include mobile {
        // font-size: 20px;
        line-height: 24px;
      }
    }

    h3 {
      font-family: "NobelWGL";
      font-size: 21px;
      font-weight: 400;
      line-height: 30px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    h4 {
      font-family: "NobelWGL";
      font-size: 21px;
      font-weight: 400;
      line-height: 23px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    h5,
    h6 {
      font-family: "NobelWGL";
      font-size: 16px;
      font-weight: 900;
      line-height: 26px;

      @include mobile {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    a {
      font-size: 16px;

      &:hover {
        color: $c-active;
        text-decoration: none;
        border-bottom: 0;
        transition: 0.5s;
      }

      @include mobile {
        font-size: 16px;
      }
    }

    strong {
      font-weight: 900;
    }

    ol,
    ul {
      margin-left: 30px;

      li {
        padding-left: 10px;
      }
    }

    @media (max-width: 767px) {
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }

  &__policy {
    display: flex;
    padding-top: 40px;

    @include mobile {
      padding-top: 30px;
    }
  }

  &__submit-button-container {
    display: flex;
    margin-top: 24px;

    @include mobile {
      margin-top: 10px;
    }
  }

  &__nav {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    margin-bottom: 36px;
    cursor: pointer;
    @media(max-width: 1024px) {
      display: flex;
      grid-template-columns: unset;

      margin-bottom: 16px;
      //padding-left: 16px;
      //padding-right: 16px;
      overflow: auto;
      ::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
      }
    }

    &-back {
      padding-bottom: 10px;
    }

    &-item {
      display: flex;
      align-items: center;
      padding: 7px 10px;
      width: 100%;
      justify-content: center;

      @media (max-width: 1024px) {
        padding: 8px 24px;
        white-space: nowrap;
      }

      &__container {
        position: relative;
        display: flex;
        justify-content: center;
        border-bottom: 1px solid $c-silver;

        &-active {
          border-bottom: 2px solid $c-black-primary;
        }
      }

      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.14px;
      color: $c-gray;

      &-num {
        font-family: 'NobelWGL-Book', sans-serif;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 1px;
        position: relative;
        top: 2px;

        &_disabled {
          cursor: default;
        }
      }
    }
  }

  .checkbox-wrapper {
    @media (max-width: 767px) {
      margin-top: 0;
    }
  }
}

.service-request-page__button.button {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'NobelWGL-Bold';
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
  padding: 12px 16px;
  letter-spacing: 1px;
  border-radius: 4px;
}

.spinner-container {
  z-index: 333;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.lds-dual-ring {
  display: inline-block;
  height: 60px;
  width: 60px;

  &:after {
    -webkit-animation: lds-dual-ring 1.2s linear infinite;
    animation: lds-dual-ring 1.2s linear infinite;
    border-color: #000 transparent;
    border-radius: 50%;
    border-style: solid;
    border-width: 3px;
    content: " ";
    display: block;
    height: 60px;
    margin: 4px;
    width: 60px;
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
